import { isMobileOnly } from 'react-device-detect';
import { colors } from '@constants/colors';
import { SwiperScreenSizes } from '@interfaces';
import { useTheme } from '@mui/material';
import { useMytaverse } from '@providers/MytaverseProvider';

export const useStyles = (isSelectedEvent: boolean) => {
  const { appTheme } = useMytaverse();
  const { breakpoints } = useTheme();

  const { backgroundColor, backgroundColorHover } = appTheme.submitButton;

  return {
    root: {
      [breakpoints.down(SwiperScreenSizes.Tablet)]: {
        width: '100%',
      },
    },
    card: {
      boxShadow: 'none',
    },
    eventPicContainer: {
      position: 'relative',
      overflow: 'hidden',
      height: '118px',
      width: '118px',
      cursor: 'pointer',
      borderRadius: '12px',
      boxSizing: 'border-box',
      [breakpoints.down(SwiperScreenSizes.Tablet)]: {
        width: 'calc(100% - 4px)',
        aspectRatio: '1/1',
        height: 'calc(100% - 4px)',
      },
      '&:hover': {
        border: `2px solid ${backgroundColorHover}`,
      },
      border: isSelectedEvent
        ? `2px solid ${backgroundColor}`
        : `2px solid ${colors.grey_100}`,
    },
    eventPicContainerDisabled: {
      filter: 'grayscale(1)',
      opacity: '0.4',
      cursor: 'default',
      '&:hover': {
        border: `2px solid ${colors.grey_100}`,
      },
    },
    chipVersion: {
      position: 'absolute',
      top: '3px',
      right: '3px',
      background: colors.grey_500,
      color: colors.white,
    },
    eventPic: {
      height: '100%',
    },
    dateTimeOverlay: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      opacity: isSelectedEvent && isMobileOnly ? 1 : 0,
      backgroundColor:
        isSelectedEvent && isMobileOnly ? 'rgb(000 000 000 / 40%)' : 'none',
      backdropFilter: isSelectedEvent && isMobileOnly ? 'blur(1px)' : 'none',

      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      justifyContent: 'center',
      height: '100%',

      '&:hover': {
        backgroundColor: 'rgb(000 000 000 / 40%)',
        backdropFilter: 'blur(1px)',
        opacity: 1,
      },
    },
    dateTimeText: {
      marginTop: '6px',
      fontWeight: 700,
      color: colors.white,
      padding: '0 10px',
      textAlign: 'center',
      fontSize: '14px',
    },
    text: {
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      padding: 0,
      marginTop: '10px',
      fontSize: '16px',
      [breakpoints.down(SwiperScreenSizes.Tablet)]: {
        '&:last-child': {
          paddingBottom: '40px',
        },
      },
    },
  };
};
